import React from "react";
import { TemplateEditorPage } from "./TemplateEditorPage";

// The template detail view reuses the editor in read-only mode so it looks
// identical to the edit screen, just with inputs disabled and no save/add/remove.
export const Template: React.VFC = () => <TemplateEditorPage readOnly />;
